// Taken from:
// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const EMAIL_VALIDATION_PATTERN_SOURCE = `[a-zA-Z0-9.!#$%&'*+/=?^_\`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*`;

export const EMAIL_VALIDATION_PATTERN = new RegExp(`^${EMAIL_VALIDATION_PATTERN_SOURCE}$`);

// Support account login pattern or EMAIL_VALIDATION_PATTERN
export const LOGIN_VALIDATION_PATTERN = new RegExp(`^(?:[a-zA-Z]+\\d{4}[a-zA-Z]+|${EMAIL_VALIDATION_PATTERN_SOURCE})$`);
